(() => {
  const isCollectionPage = () => window.location.pathname.includes('/collections/');
  const section = document.querySelector('[data-collection-tracking]');
  if (!isCollectionPage() || !section) return;

  // Filters replace the section; its Shopify wrapper stays mounted.
  const container = section.parentElement;
  const selector = '[data-collection-tracking] [data-collection-product-id]';
  const observed = new Set();
  const impressed = new Set();

  function payload(card) {
    const collection = card.closest('[data-collection-tracking]');
    if (!isCollectionPage() || !collection || !container.contains(card)) return null;
    return {
      item_name: card.dataset.collectionProductName,
      item_id: card.dataset.collectionProductId,
      collection_url: new URL(collection.dataset.collectionUrl, window.location.origin).href,
      collection_name: collection.dataset.collectionName,
    };
  }

  function emit(event, item) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...item });
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting || entry.intersectionRatio < 0.01) return;
      const item = payload(entry.target);
      if (!item) return;
      const key = `${item.collection_name}:${item.item_id}`;
      if (!impressed.has(key)) {
        emit('product_impression', item);
        impressed.add(key);
      }
      observer.unobserve(entry.target);
      observed.delete(entry.target);
    });
  }, { threshold: 0.01 });

  function observeProducts() {
    for (const card of observed) {
      if (!container.contains(card)) {
        observer.unobserve(card);
        observed.delete(card);
      }
    }
    container.querySelectorAll(selector).forEach((card) => {
      const item = payload(card);
      if (!item || impressed.has(`${item.collection_name}:${item.item_id}`) || observed.has(card)) return;
      observed.add(card);
      observer.observe(card);
    });
  }

  container.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    const card = link && link.closest('[data-collection-product-id]');
    if (!card) return;
    // Wishlist, quick view, swatches and add-to-cart are not product navigation.
    const destination = new URL(link.href, window.location.origin);
    if (destination.origin !== window.location.origin || !destination.pathname.includes('/products/')) return;
    const item = payload(card);
    if (item) emit('product_click', item);
  });

  observeProducts();
  new MutationObserver(observeProducts).observe(container, { childList: true, subtree: true });
})();
